export enum SortOrder {
    Asc = "asc",
    Desc = "desc",
}

export interface ListResponse<T = any> {
    count: number;
    data: T;
}

export interface UserListResponse<T = any> {
    count: number;
    data: T;
    quiltyCount: any;
    gsxCount: any;
}

export interface ListQuery {
    skip?: string;
    take?: string;
    sort?: string;
    order?: SortOrder;
}
